import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BRAND_ASSET_GROUPS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('BRAND_ASSET_GROUPS');
export const BRAND_ASSET_GROUPS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BRAND_ASSET_GROUPS_CRUD_ACTION_CONSTANTS
);
